<template>
  <div class="asset-carousel to-edge-mobile" :class="{ bleedout: data.fullWidth, 'to-edge': data.fullWidth }">
    <Carousel
      :ref="carousel"
      v-if="data"
      :items="data.assets"
      :hide-chevron="!data.alwaysShowArrows"
      :main-content-selector="'.asset-image-inner'"
      :configs="carouselConfigs"
      :class="{
        fullscreen: data.carouselStyle === 'fullscreen',
        'carousel left-aligned': data.carouselStyle === 'left-aligned',
        cover: data.fit === 'cover',
        contain: data.fit === 'contain',
        'no-description': !data.showDescription,
      }"
    >
      <template v-slot:default="{ item }">
        <suspense>
          <ContentfulResponsiveAsset v-bind="item" v-if="item">
            <template v-if="!data.showDescription" v-slot:description-override>
              <span></span>
            </template>
          </ContentfulResponsiveAsset>
        </suspense>
      </template>
    </Carousel>
  </div>
</template>

<script>
import Carousel from '@/components/commons/Carousel.vue';
import ContentfulResponsiveAsset from './ContentfulResponsiveAsset.vue';
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import { ref, computed } from 'vue';

export default {
  components: {
    Carousel,
    ContentfulResponsiveAsset,
  },

  props: contentfulProps,

  async setup(props, ctx) {
    const { data, init } = useContentful('imageCarousel', props, ctx, {});

    const carousel = ref(null);

    const carouselConfigs = computed(() => ({
      spaceBetween: 16,
      loop: data.value?.loop,
      initialSlide: 0,
    }));

    await init();

    return {
      data,
      carousel,
      carouselConfigs,
    };
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';
@import '@/pixel/style/mixins';

/* left aligned version of asset carousel */
.left-aligned {
  :deep(.swiper-slide) {
    width: auto;
  }

  :deep(.carousel-item) {
    .description {
      width: 100%;

      @media (max-width: $tablet-breakpoint) {
        width: 70%;
      }
      @media (max-width: $mobile-breakpoint) {
        width: 60%;
      }
    }
    .asset-image-inner > .image {
      img {
        min-width: 100%;
        min-height: 250px;
        height: 600px;

        @media (max-width: $tablet-breakpoint) {
          height: 420px;
        }
        @media (max-width: $mobile-breakpoint) {
          height: auto;
        }
      }
    }
  }
}

/* Fullscreen version of asset carousel (default version) */
.fullscreen {
  :deep(.carousel-item) {
    height: 100%;
    .contentful-responsive-asset {
      height: 100%;
    }
    .image {
      overflow: hidden;
    }
  }

  /* carousel uses external library to modify dom and needs some touchups.. */
  :deep(.swiper-slide-duplicate) {
    .skeleton {
      border-radius: revert;
      background: revert;
      color: revert;
      animation: revert;
    }
    /* purgecss ignore */
    &:not(.swiper-slide-active):not(.swiper-slide-duplicate-prev):not(.swiper-slide-duplicate-next) .asset-image {
      display: none;
    }
  }
}

/* Generic carousel class selector for creating the core of the design associated with the branch off styles */
.asset-carousel {
  overflow: hidden;
  padding-top: 10px;

  :deep(.carousel-item) {
    .contentful-responsive-asset {
      display: flex;
      flex-direction: column;
    }
    .description {
      flex: 0 1 auto;
      margin-top: 20px;
      margin-bottom: 5px;
    }
    .asset-image-inner > .image {
      flex: 1 1 auto;
      img {
      }
    }
  }

  &.cover {
    img,
    video {
      object-fit: cover;
    }
  }
  &.contain {
    img,
    video {
      object-fit: contain;
    }
  }
  &.no-description {
    .contentful-responsive-asset {
      .description {
        display: none;
      }
    }
  }
}

.container {
  @media (max-width: $mobile-breakpoint) {
    margin-left: 4vw;
    padding-left: 0px;
    width: 100%;
  }
}
</style>
